import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { StorageService } from "./storage.service";
import { ICredentials } from "../models/ICredentials";
import * as jwt_decode from "jwt-decode";
import { BehaviorSubject } from "rxjs";

const url = "/api/auth";
const cookieName = "timetracking_auth";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  // this is really for when user actively logs in or out
  private loggedInSubject = new BehaviorSubject<boolean>(false);
  loggedIn$ = this.loggedInSubject.asObservable();

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {
    if (this.isLoggedIn()) {
      this.loggedInSubject.next(true);
    }
  }
  tryGetUsername() {
    return this.storageService.getRememberedUserName();
  }
  login(credentials: ICredentials) {
    return this.http.post<IAuthToken>(`${url}/login`, credentials).pipe(
      map((token) => {
        if (credentials.remember) {
          this.storageService.rememberUserName(credentials.username);
        } else {
          this.storageService.forgetUserName();
        }
        this.storageService.set(cookieName, token.token);
        this.loggedInSubject.next(true);
        return true;
      })
    );
  }
  loginForUser(token: IAuthToken) {
    this.storageService.set(cookieName, token.token);
    this.loggedInSubject.next(true);
  }
  logout() {
    this.storageService.remove(cookieName);
    this.loggedInSubject.next(false);
  }
  isLoggedIn() {
    const token = this.getToken();
    if (!token || this.isTokenExpired()) {
      this.logout();
      return false;
    }
    return true;
  }
  isAdmin() {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    const role = this.getRole(token);
    return role === "Admin";
  }
  getToken() {
    return this.storageService.get(cookieName);
  }
  isTokenExpired() {
    // TODO do we want this to expire since its just us?
    // if this is expired, we need to get rid of it better.. right now its getting stuck andi cant get past login
    return false;
    const token = this.storageService.get(cookieName);
    // no token so uh, yea its expired
    if (!token) {
      return true;
    }
    const date = this.getTokenExpirationDate(token);
    if (!date) {
      return false;
    }
    return date.valueOf() < new Date().valueOf();
  }
  getUserId() {
    const token = this.getToken();
    if (token) {
      return this.getUserIdFromToken(token);
    }
  }

  getUserIdFromToken(token: string): number {
    const decoded = jwt_decode(token);
    return parseInt(decoded.id, 10);
  }
  private getRole(token: string): string {
    const decoded = jwt_decode(token);
    return decoded.rol;
  }
  public getUserRoles(): string[] {
    const token = this.getToken();
    if (!token) {
      return [];
    }
    const decoded = jwt_decode(token);
    return decoded.roles;
  }
  private getTokenExpirationDate(token: string): Date {
    const decoded = jwt_decode(token);

    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }
}

export interface IAuthToken {
  token: string;
  expiresIn: string;
  id: string;
}
